import ReactDOM from 'react-dom/client';

import { App } from 'App';
import { AppsSchema } from 'App/types';
import { AppWithMockedApi as MashreqApp } from 'impactApp/App';

const Apps: AppsSchema = [
  {
    id: 'mashreq',
    Component: MashreqApp,
  },
];

const renderApp = () => {
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App apps={Apps} />);
};

renderApp();
